const itemsProgressReducer = (data = "unset", action) => {
    switch(action.type){
        case 'SET_ITEM_PROGRESS':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default itemsProgressReducer;